import * as React from "react";
const SvgHidden = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.059 2a.75.75 0 1 0-1.118 1l17 19a.75.75 0 0 0 1.118-1l-2.607-2.913c2.846-1.666 4.57-4.2 5.238-5.793a.754.754 0 0 0-.018-.628C22.459 9.19 18.404 4.25 11.756 4.25c-1.819 0-3.426.372-4.82.965L4.059 2Zm3.942 4.406 1.43 1.598a4.75 4.75 0 0 1 6.255 6.991l1.743 1.948c2.488-1.365 4.059-3.505 4.738-4.92-1.241-2.267-4.81-6.273-10.411-6.273-1.401 0-2.65.249-3.755.656Zm6.667 7.45a3.25 3.25 0 0 0-4.218-4.714l4.218 4.715Zm-9.7-5.728a.75.75 0 0 0-.936-1.171C2.087 8.512.855 10.407.31 11.706a.747.747 0 0 0 .018.628c1.214 2.477 5.268 7.416 11.917 7.416.883 0 1.717-.088 2.502-.247a.75.75 0 1 0-.297-1.47c-.688.14-1.422.217-2.205.217-5.601 0-9.17-4.005-10.412-6.273.516-1.075 1.555-2.585 3.135-3.849ZM8 11.25a.75.75 0 0 1 .75.75 3.25 3.25 0 0 0 2.975 3.239.75.75 0 0 1-.124 1.494A4.75 4.75 0 0 1 7.25 12a.75.75 0 0 1 .75-.75Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgHidden;
